import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class LoadingService {
	private loadings: object = {};
	public isLoading: BehaviorSubject<boolean> = new BehaviorSubject(false);

	constructor() {}

	show(name = 'default') {
		this.loadings[name] = true;
		this.isLoading.next(true);
	}

	hide(name = 'default') {
		this.loadings[name] = false;
		this.isLoading.next(false);
	}

	register(name = 'default') {
		if (!this.loadings.hasOwnProperty(name)) this.loadings[name] = false;
	}

	unregister(name = 'default') {
		if (this.loadings.hasOwnProperty(name)) {
			delete this.loadings[name];
		}
	}

	get(name = 'default') {
		return this.loadings[name];
	}
}
